import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * @function PrivateRoute
 * @description Guards authenticated admin screens. Avoids location subscriptions
 * so the layout chrome does not rerender on every screen switch.
 * @returns JSX for PrivateRoute
 */
const PrivateRoute = ({ children }) => {
  const accessToken = useSelector((store) => store.AuthReducer?.accessToken);
  if (!accessToken) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default PrivateRoute;
